import React, { useState } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Toggle, Panel } from "./styles"

export const ReadMore = ({ id, children }) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()
  return (
    <>
      <Toggle
        type="button"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(!open)}
      >
        <span aria-hidden="true">{open ? "−" : "+"}</span>
        {open ? t("readLess") : t("readMore")}
      </Toggle>
      <Panel id={id} hidden={!open}>
        {children}
      </Panel>
    </>
  )
}
